import axios from 'axios'
import Cookie from 'js-cookie'
import CryptoJS from 'crypto-js'

export const baseUrl = 'http://www.eisong.com:8080/' //'http://192.168.2.10:8111/' // 'http://www.eisong.com:8080/' // 'http://152.68.21.17:8111/' // 

// 附件
export const aliUrl = 'https://bwlover.oss-cn-hangzhou.aliyuncs.com/'

let appId = '8111'
let appKey = '8dbb71a37803a96e287bae2819d9d9d8'

/**
 * 通用HTTP请求方法
 * 上传附件时使用此方法获取上传地址，isreturn必须为true
 * METHOD包含GET、POST
 */
export const httpRequest = (params, method = 'GET', isreturn) => {
    let paramsTrim = {}

    let timestamp = Math.round(new Date().getTime() / 1000)
    let paramSort = Object.keys(params).sort()
    let signStr = appId + appKey + timestamp
    let sp = ''
    let postUrl = baseUrl + '?action=' + params.action + '&app_id=' + appId + '&timestamp=' + timestamp
    let postParams = {}

    for (let i = 0; i < paramSort.length; i++) {
        if (params[paramSort[i]] != undefined) {
            signStr += sp + paramSort[i] + '=' + params[paramSort[i]]
            sp = '&'
            paramsTrim[paramSort[i]] = params[paramSort[i]]
        }
    }

    paramsTrim.app_id = appId
    paramsTrim.timestamp = timestamp
    paramsTrim.sign = CryptoJS.MD5(signStr).toString().toUpperCase()
    postUrl += '&sign=' + paramsTrim.sign
    if (isreturn) {
        let returnStr = baseUrl + '?'
        let sp = ''
        for (let key in paramsTrim) {
            returnStr += sp + key + '=' + paramsTrim[key]
            sp = '&'
        }
        return returnStr
    }

    // 登录参数
    let headers = {}
    let admin = getCookie('admin')
    if (admin['aid']) {
        headers['loginId'] = admin.aid
    }

    if (method == "GET") {
        return new Promise((resolve, reject) => {
            axios.get(baseUrl, {
                params: paramsTrim,
                headers: headers
            }).then((response) => {
                resolve(response.data)
            }).catch((error) => {
                resolve({
                    error: true,
                    msg: error
                })
            })
        })
    } else {
        // 去除放入地址栏中的参数
        delete paramsTrim.action
        delete paramsTrim.app_id
        delete paramsTrim.timestamp
        delete paramsTrim.sign
        return new Promise((resolve, reject) => {
            axios.post(postUrl, paramsTrim, {
                    headers: headers
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    resolve({
                        error: true,
                        msg: error
                    })
                })
        })
    }
}

// 获取COOKIE
export const getCookie = (type) => {
    let cookiestr = Cookie.get(type)
    return cookiestr ? JSON.parse(aesDecrypt(cookiestr)) : {}
}
// 密码强度校验（返回布尔值）：8-30 位，且数字/字母/特殊字符三类中至少含 2 种。
// 原 passwordCheck 返回的是「首个未命中的字符类别编号」，且它的类别表里有个永远不会被推入的 5，
// 导致任何 ≥ 6 位的密码都返回真值（当成布尔用必错：当通过用会全部报错，当不通过用会全部放行），
// 已删除并换成本函数，调用方只需关心 true/false。
export const passwordValid = value => {
    const v = String(value || '')
    if (v.length < 8 || v.length > 30) {
        return false
    }
    let kinds = 0
    if (/\d/.test(v)) kinds++
    if (/[a-zA-Z]/.test(v)) kinds++
    if (/[^0-9a-zA-Z]/.test(v)) kinds++
    return kinds >= 2
}

// 加密字符串
export const aesEncrypt = (codeString) => {
    var key = CryptoJS.enc.Utf8.parse(appKey);
    var srcs = CryptoJS.enc.Utf8.parse(codeString);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: CryptoJS.enc.Utf8.parse('87abe96b2dba9799'),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    })

    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

// 解密字符串
export const aesDecrypt = (cipherText) => {
    let key = CryptoJS.enc.Utf8.parse(appKey)
    let iv = CryptoJS.enc.Utf8.parse('87abe96b2dba9799')
    // 返回的是一个Word Array Object，其实就是Java里的字节数组
    let decrypted = CryptoJS.AES.decrypt(cipherText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
}